import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RvGridComponent } from './rv-grid/rv-grid.component';
import { RvGridModule } from './rv-grid/rv-grid.module';
import { RvCreateComponent } from './rv-create/rv-create.component';
import { RvCreateModule } from './rv-create/rv-create.module';
import { CanDeactivateGuard } from '../../core'
import { AddEditCustomerGuard } from '../../admin/accounts/manage-customers/add-edit-customer/add-edit-customer.guard'
import { RvReportComponent } from './rv-report/rv-report.component';
import { InteractiveReportComponent } from './interactive-report/interactive-report.component';
import { ReviewerModule } from '../../common/component/reviewer/reviewer.module';
import { ReviewerComponent } from '../../common/component/reviewer/reviewer.component';

export const routes: Routes = [
    { path: 'monitor', component: RvGridComponent },
    { path: 'create', component: RvCreateComponent, canDeactivate: [AddEditCustomerGuard] },
    { path: 'upload-and-create', component: RvCreateComponent, canDeactivate: [AddEditCustomerGuard] },
    { path: 'review', component: ReviewerComponent, canDeactivate: [AddEditCustomerGuard] },
    { path: 'rv-report', component: RvReportComponent },
    { path: 'interactive-report', component: InteractiveReportComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)
    ,RvGridModule
    ,RvCreateModule
    ,ReviewerModule
    ],
  exports: [RouterModule]
})
export class RateAvailRoutingModule { }
